import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalCookiesComponent } from '../../modal-cookies/modal-cookies.component';
import { ModalPrivacyPolicyComponent } from '../../modal-privacy-policy/modal-privacy-policy.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  constructor(private dialog: MatDialog) {}

  public openModal(modal: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      disableClose: true,
      autoFocus: false,
      panelClass: ['modal__full-screen']
    };
    if (modal === 'cookies') {
      this.dialog.open(ModalCookiesComponent, dialogConfig.data);
    } else {
      this.dialog.open(ModalPrivacyPolicyComponent, dialogConfig.data);
    }
  }
}
